/**
 * Sel-2 problem spotlight — draws L-shaped callout lines (horizontal then
 * vertical) from each feature to a % target on the background image.
 * Recalculates on resize so lines stay locked as the cover image reflows.
 */
(function () {
  'use strict';

  var MQ = window.matchMedia('(min-width: 900px)');

  function parsePct(value, fallback) {
    var n = parseFloat(value);
    return isNaN(n) ? fallback : Math.max(0, Math.min(100, n));
  }

  function draw(root) {
    var container = root.querySelector('[data-sel-2-problem-connectors]');
    var media = root.querySelector('[data-sel-2-problem-media]');
    var items = root.querySelectorAll('[data-sel-2-problem-item]');
    if (!container || !media) return;

    container.innerHTML = '';

    if (!MQ.matches || !root.classList.contains('sel-2-problem-spotlight--connectors')) return;

    var stage = root.querySelector('[data-sel-2-problem-stage]') || container;
    var stageRect = stage.getBoundingClientRect();
    var mediaEl =
      media.querySelector('.sel-2-problem-spotlight__media-img--desktop') ||
      media.querySelector('.sel-2-problem-spotlight__media-placeholder') ||
      media.querySelector('img') ||
      media;
    var mediaRect = mediaEl.getBoundingClientRect();
    var stroke =
      root.getAttribute('data-connector-color') ||
      getComputedStyle(root).getPropertyValue('--sel-2-ps-line').trim() ||
      '#007BFF';
    var strokeWidth = parseFloat(root.getAttribute('data-connector-stroke'));
    if (isNaN(strokeWidth) || strokeWidth <= 0) strokeWidth = 1;
    var dotRadius = parseFloat(root.getAttribute('data-connector-dot'));
    if (isNaN(dotRadius)) dotRadius = 4;

    var svgNS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(svgNS, 'svg');
    svg.setAttribute('class', 'sel-2-problem-spotlight__connectors-svg');
    svg.setAttribute('width', String(Math.max(1, stageRect.width)));
    svg.setAttribute('height', String(Math.max(1, stageRect.height)));
    svg.setAttribute('viewBox', '0 0 ' + Math.max(1, stageRect.width) + ' ' + Math.max(1, stageRect.height));
    svg.setAttribute('aria-hidden', 'true');

    Array.prototype.forEach.call(items, function (item) {
      var icon = item.querySelector('.sel-2-problem-spotlight__feature-icon') || item;
      var iconRect = icon.getBoundingClientRect();

      /* Start just left of the feature icon, centered vertically on it */
      var startX = iconRect.left - stageRect.left - 8;
      var startY = iconRect.top + iconRect.height / 2 - stageRect.top;

      var tx = parsePct(item.getAttribute('data-target-x'), 28);
      var ty = parsePct(item.getAttribute('data-target-y'), 50);
      var endX = mediaRect.left - stageRect.left + (mediaRect.width * tx) / 100;
      var endY = mediaRect.top - stageRect.top + (mediaRect.height * ty) / 100;

      /* Keep the tip in the image (left of the feature column) */
      if (endX >= startX - 12) {
        endX = Math.max(12, startX - 48);
      }

      /*
        L-shape: horizontal from feature → target X, then vertical → target Y.
        Elbow sits at (endX, startY).
      */
      var path = document.createElementNS(svgNS, 'path');
      path.setAttribute(
        'd',
        'M ' +
          startX.toFixed(1) +
          ' ' +
          startY.toFixed(1) +
          ' L ' +
          endX.toFixed(1) +
          ' ' +
          startY.toFixed(1) +
          ' L ' +
          endX.toFixed(1) +
          ' ' +
          endY.toFixed(1)
      );
      path.setAttribute('class', 'sel-2-problem-spotlight__line');
      path.setAttribute('fill', 'none');
      path.setAttribute('stroke', stroke);
      path.setAttribute('stroke-width', String(strokeWidth));
      path.setAttribute('stroke-linecap', 'round');
      path.setAttribute('stroke-linejoin', 'round');
      svg.appendChild(path);

      if (dotRadius > 0) {
        var dot = document.createElementNS(svgNS, 'circle');
        dot.setAttribute('cx', endX.toFixed(1));
        dot.setAttribute('cy', endY.toFixed(1));
        dot.setAttribute('r', String(dotRadius));
        dot.setAttribute('class', 'sel-2-problem-spotlight__line-dot');
        dot.setAttribute('fill', stroke);
        svg.appendChild(dot);
      }
    });

    container.appendChild(svg);
  }

  function bind(root) {
    var raf = 0;
    function schedule() {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        draw(root);
      });
    }

    schedule();
    window.addEventListener('resize', schedule);
    Array.prototype.forEach.call(root.querySelectorAll('img'), function (img) {
      if (!img.complete) img.addEventListener('load', schedule);
    });

    if (typeof ResizeObserver === 'function') {
      var ro = new ResizeObserver(schedule);
      ro.observe(root);
      var media = root.querySelector('[data-sel-2-problem-media]');
      if (media) ro.observe(media);
      var content = root.querySelector('[data-sel-2-problem-content]');
      if (content) ro.observe(content);
    }

    if (MQ.addEventListener) MQ.addEventListener('change', schedule);
    else if (MQ.addListener) MQ.addListener(schedule);
  }

  function init() {
    var roots = document.querySelectorAll('[data-sel-2-problem-spotlight]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.getAttribute('data-sel-2-problem-ready')) return;
      root.setAttribute('data-sel-2-problem-ready', 'true');
      bind(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
